import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, CheckCircle2, ShieldAlert } from "lucide-react";

function Shell({ testId, children }) {
  return (
    <div className="dark min-h-screen bg-[#070809] text-foreground flex items-center justify-center p-6" data-testid={testId}>
      <div className="max-w-sm w-full rounded-2xl border border-white/10 bg-white/[0.03] p-7 text-center space-y-3">{children}</div>
    </div>
  );
}

// Start URL inside Safe Exam Browser: swaps the one-time token for a session, then reloads into the exam room.
export function SebStart() {
  const { token } = useParams();
  const { loading, adoptSession } = useAuth();
  const [err, setErr] = useState("");
  const once = useRef(false);
  useEffect(() => {
    // Wait for any earlier session refresh to finish so it can't overwrite the exam session.
    if (loading || once.current) return;
    once.current = true;
    api.post("/seb/start", { token })
      .then(({ data }) => { adoptSession(data); window.location.replace(`/candidate/exam/${data.cand_id}`); })
      .catch((e) => setErr(e.response?.data?.detail || "This link didn't work. Quit and open the test again from your application."));
  }, [token, loading]); // eslint-disable-line react-hooks/exhaustive-deps
  return err ? (
    <Shell testId="seb-start-error"><ShieldAlert className="h-8 w-8 text-rose-400 mx-auto" /><p className="text-sm text-muted-foreground">{err}</p><a href="/seb/quit" className="text-sm text-primary hover:underline" data-testid="seb-start-quit">Quit Safe Exam Browser</a></Shell>
  ) : (
    <Shell testId="seb-start"><Loader2 className="h-8 w-8 text-primary animate-spin mx-auto" /><p className="text-sm text-muted-foreground">Opening your test…</p></Shell>
  );
}

export function SebQuit() {
  return (
    <Shell testId="seb-quit"><CheckCircle2 className="h-8 w-8 text-emerald-400 mx-auto" /><h1 className="font-display text-lg font-semibold">All done</h1><p className="text-sm text-muted-foreground">Safe Exam Browser closes now. If it doesn't, you can close it yourself.</p></Shell>
  );
}
